<!-- ----------------------------------------------- -->
<template>
  <v-card id="iu-dialog" class="com-mb-dialog normal">
    <v-row class="com-mb-dialog-header">
      <span class="com-mb-dialog-title">{{ text.title }}</span>
      <v-tooltip right max-width="300" class="mr-2" nudge-bottom="120">
        <template v-slot:activator="{ on }">
          <v-icon color="white" light v-on="on">help_outline</v-icon>
        </template>
        <span>{{ text.hint }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn v-show="!isSmall && !isFull" small icon color="white" @click="minWindow">
        <v-icon>minimize</v-icon>
      </v-btn>
      <v-btn v-show="!isFull && !isSmall" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn v-show="isFull || isSmall" small icon color="white" @click="reductionWindow">
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents">
      <v-col class="com-mb-dialog-frame" :class="isSmall ? 'pa-2' : ''">
        <iu-select :isSmall="isSmall"></iu-select>
        <iu-link v-show="!isSmall"></iu-link>
        <iu-legend v-show="!isSmall"></iu-legend>
        <iu-opacity v-show="!isSmall"></iu-opacity>
        <iu-navi v-show="!isSmall"></iu-navi>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 浸水想定ダイアログ
 * Inundation.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import IuSelect from "./../../../components/mb/IuSelect";
import IuLink from "./../../../components/mb/IuLink";
import IuLegend from "./../../../components/mb/IuLegend";
import IuOpacity from "./../../../components/mb/IuOpacity";
import IuNavi from "./../../../components/mb/IuNavi";

export default {
  /** タグ名 */
  name: "mb-inundation",
  mixins: [mixin],
  components: { IuSelect, IuOpacity, IuLink, IuLegend, IuNavi },
  data() {
    return {
      isFull: false,
      isSmall: false,
      /** 文字列リソース */
      text: {
        title: "浸水想定",
        hint:
          "「提供している浸水想定区域図は、国土交通省の河川事務所が作成した想定最大規模（L2)の浸水想定区域図です。浸水想定区域図には、支川の決壊による氾濫、シミュレーションの前提となる降雨を超える規模の降雨による氾濫、高潮及び内水による氾濫等を考慮していませんので、この洪水浸水想定区域に指定されていない区域においても浸水が発生する場合や、想定される水深が実際の浸水深と異なる場合があります。」",
      },
    };
  },
  computed: {
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          towns: this.$store.state.map.towns,
          townsAcqTime: this.$store.state.map.townsAcqTime,
          zoom: this.$store.state.map.zoom,
        };
      },
    },

    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          townsAcqTime: this.$store.state.inundation.inundationParam
            .townsAcqTime,
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam,
        };
      },
    },
    /**
     * 表示範囲のハザードマップ一覧
     */
    hazardMap: {
      get() {
        return {
          hazardMap: this.$store.state.inundation.hazardMap,
        };
      },
    },
  },

  mounted() {
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "Inundation");
  },
  watch: {
    reqParam() {
      if (
        this.reqParam.zoom >= 12 &&
        this.reqParam.townsAcqTime != this.inundations.townsAcqTime
      ) {
        this.getInundations();
      }
    },
  },
  /** メソッド */
  methods: {
    /** 画面拡大 */
    expansionWindow() {
      var dlg = document.getElementById("iu-dialog");
      dlg.className = "com-mb-dialog large v-card v-sheet theme--light";
      this.isFull = true;
    },
    /** 画面を戻す */
    reductionWindow() {
      var dlg = document.getElementById("iu-dialog");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";
      if (this.isFull) {
        this.isFull = false;
      } else {
        this.isSmall = false;
      }
    },
    /** 画面最小化 */
    minWindow() {
      var dlg = document.getElementById("iu-dialog");
      dlg.className = "com-mb-dialog small v-card v-sheet theme--light";
      this.isSmall = true;
    },

    /** 画面を閉じる */
    closeDlg() {
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    /**
     * 表示範囲の浸水想定区域データ取得
     */
    getInundations() {
      setTimeout(() => {
        this.$store.dispatch("inundation/getInundations", {
          townsAcqTime: this.reqParam.townsAcqTime,
          towns: this.reqParam.towns,
        });
      }, 500);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
  .small {
    width: 50%;
    max-width: 400px;
    height: 110px;
    bottom: 4px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
  .small {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 110px;
    bottom: 4px;
  }
}

#iu-dialog {
  right: 4px;
}
</style>

